import React, { useMemo, useState } from 'react';
import meetingState from '../../../../../data/constants/meetingState';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useMyUserId } from '../../../../../data/hooks/sessionHooks';
import UserAvatar from '../../../../elements/icons/UserAvatar';
import styles from './OthersInvited.module.scss';
import MeetingPeer from '../MeetingPeer/MeetingPeer';

function OthersInvited(props) {
    const { meeting, exclude = [] } = props,
        i18n = useI18n(),
        { invited } = meeting,
        selfId = useMyUserId(),
        [others, confirmed, declined, pending] = useMemo(() => {
            const others = invited.filter((invitee) => !exclude.includes(invitee.user.id) && invitee.user.id != selfId),
                accepted = others.filter((invitee) => invitee.state == meetingState.CONFIRMED),
                declined = others.filter((invitee) => invitee.state == meetingState.CANCELLED),
                pending = others.filter((invitee) => invitee.state == meetingState.PENDING);
            return [others, accepted, declined, pending];
        }, [meeting, exclude, selfId]),
        stateCounts = [
            { label: i18n['meeting.status.confirmed.count'].replace('{0}', confirmed.length), count: confirmed.length },
            { label: i18n['meeting.status.rejected.count'].replace('{0}', declined.length), count: declined.length },
            { label: i18n['meeting.status.pending.count'].replace('{0}', pending.length), count: pending.length },
        ].filter((item) => item.count),
        [showOthers, setShowOthers] = useState(false);

    if (!others.length) return null;

    return (
        <>
            <div className={styles.OthersInvited} onClick={() => setShowOthers(!showOthers)}>
                <div className={styles.avatars}>
                    {others.map((invitee, index) => {
                        return (
                            <div key={index} style={{ width: `${100 / others.length}%` }}>
                                <UserAvatar user={invitee.user} size={32} />
                            </div>
                        );
                    })}
                </div>
                <div className={styles.description}>
                    <div className={styles.total}>{others.length == 1 ? i18n['meeting.others.count.singular'] : i18n['meeting.others.count.plural'].replace('{0}', others.length)}</div>
                    <div className={styles.grouped}>{stateCounts.map((item) => item.label).join(', ')}</div>
                </div>
            </div>
            {showOthers ? (
                <div className={styles.othersDetailed}>
                    {others.map((invitee, index) => (
                        <MeetingPeer key={index} user={invitee.user} />
                    ))}
                </div>
            ) : null}
        </>
    );
}

export default OthersInvited;
